import { render, staticRenderFns } from "./ZarinPalCallback.vue?vue&type=template&id=74639c7e&scoped=true"
import script from "./ZarinPalCallback.vue?vue&type=script&lang=js"
export * from "./ZarinPalCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74639c7e",
  null
  
)

export default component.exports